<template>
  <v-tabs>
    <v-tab
        :to="{
        name: 'PatientRecordPAProgressStatus',
        params: {
          patientId,
        },
      }"
    >
      {{ $ucfirst($t("journeyBehaviourChangeGoals.status")) }}
    </v-tab>
    <v-tab
        :to="{
        name: 'PatientRecordPAProgressProgress',
        params: {
          patientId,
        },
      }"
    >
      {{ $ucfirst($t("journeyProgress.progress")) }}
    </v-tab>
  </v-tabs>
</template>

<script>
import { mapGetters } from "vuex";

/**
 * Component PAProgressTabs.vue
 *
 * @module PAProgressTabs
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.5] app/src/APP_DASHBOARD/templates/components/Parts/PAProgressTabs.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: "PAProgressTabs",
  computed: {
    ...mapGetters({
      patientId: "patientSummary/id",
    }),
  },
};
</script>

<style lang="scss">
</style>